<template>
  <section class="about-why">
    <div class="container">
      <h2 class="about-why__title">Почему X-Global появился?</h2>

      <ul class="about-why__problems">
        <li>
          <span>
            Подделки, фальшивые компании, срыв сделок, дебиторская задолженность
          </span>
        </li>
        <li>
          <span
            >Площадки, где приходится очень много платить за продвижение</span
          >
        </li>
        <li><span>Непрозрачные контрагенты, которых сложно проверить</span></li>
      </ul>

      <p class="about-why__solution">
        <span class="highlight">Мы хотели решить эту проблему</span>
        — и построили платформу, где <br />
        <strong>проверка, сделка и безопасность идут рука об руку.</strong>
      </p>
      <div class="about-why__values">
        <!-- <div class="about-why__circle-wrapper"> -->
        <h3 class="about-why__circle">Наши ценности</h3>
        <!-- </div> -->
        <div class="about-why__cards container">
          <div class="about-why__cards-grid">
            <div class="value-card top-left">
              <div class="value-card-title">
                <div class="box">
                  <img src="@/assets/images/about-icons/value-1.svg" alt="" />
                </div>
                <h4>Прозрачность</h4>
              </div>
              <p>
                Каждый участник — проверен, каждый отчёт — документально
                обоснован
              </p>
            </div>
            <div class="value-card top-right">
              <div class="value-card-title">
                <div class="box">
                  <img src="@/assets/images/about-icons/value-2.svg" alt="" />
                </div>

                <h4>Доступность</h4>
              </div>

              <p>
                Бесплатный вход, понятный интерфейс, цена без скрытых условий
              </p>
            </div>
            <div class="value-card bottom-left">
              <div class="value-card-title">
                <div class="box">
                  <img src="@/assets/images/about-icons/value-3.svg" alt="" />
                </div>

                <h4>Надёжность</h4>
              </div>

              <p>Мы не просто даём данные, а показываем, кому можно доверять</p>
            </div>
            <div class="value-card bottom-right">
              <div class="value-card-title">
                <div class="box">
                  <img src="@/assets/images/about-icons/value-4.svg" alt="" />
                </div>

                <h4>Эволюция</h4>
              </div>

              <p>Слушаем пользователей и обновляем продукт каждую неделю</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.about-why {
  padding: 64px 20px;
  background-image: url("../../assets/images/background-values.png");
  color: rgba(62, 62, 62, 1);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-position: top center;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.about-why__title {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.about-why__problems {
  list-style: none;
  padding: 24px;
  margin: 60px 0;
  width: fit-content;
  border: 1px solid rgba(168, 2, 32, 1);
  border-radius: 30px;
  background: #fff;
}
.about-why__problems li {
  font-size: 22px;
  margin: 10px 0;
  position: relative;
  padding-left: 24px;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  span {
    margin-left: 12px;
  }
}
.about-why__problems li::before {
  content: "❌";
  position: absolute;
  left: 0;
  top: 0;
}
.about-why__solution {
  font-size: 30px;
  margin: 120px 0;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 24px 0;
    line-height: 35px;
  }
}
.about-why__solution .highlight {
  background: rgba(0, 199, 130, 1);
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
}
.about-why__values {
  position: relative;
  margin: 460px 0 160px;

  @media (max-width: 768px) {
    margin: 0;
  }
}

.about-why__circle-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  @media (max-width: 768px) {
    display: none;
  }
}

.about-why__cards-grid {
  position: relative;
  width: 100%;
  height: 700px;
  margin: 0 auto;

  @media (max-width: 768px) {
    height: unset;
  }
}

.about-why__cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  //   max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.value-card {
  position: absolute;
  width: 390px;
  background: #fff;
  padding: 20px;
  border-radius: 30px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  text-align: left;

  @media (max-width: 768px) {
    position: unset;
    width: 100%;
    margin-bottom: 12px;
  }

  &-title {
    background: rgba(0, 199, 130, 1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 8px;
    gap: 12px;
    font-size: 30px;

    .box {
      background: #fff;
      border-radius: 10px;
      width: 56px;
      height: 56px;
      text-align: center;
      align-items: center;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 40px;
        height: 40px;
      }
    }
    h4 {
      color: rgba(255, 255, 255, 1);
      font-weight: 400;
      margin-bottom: 0;
      font-size: 30px;

      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
  }
  p {
    font-size: 22px;
    margin-top: 12px;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
}

.value-card img {
  width: 24px;

  @media (max-width: 768px) {
    width: 20px;
  }
}

.top-left {
  top: 0;
  left: 0;
}
.top-right {
  top: 0;
  right: 0;
}
.bottom-left {
  bottom: 0;
  left: 0;
}
.bottom-right {
  bottom: 0;
  right: 0;
}

.about-why__circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 40px 30px;
  border-radius: 100px;
  box-shadow: 1px 1px 1px 0px rgba(129, 135, 189, 0.15);
  font-weight: 700;
  font-size: 45px;
  z-index: 1;
  color: rgba(0, 199, 130, 1);
}
</style>
